import React from 'react';

interface IShortDaysSquare {
    isExpired: boolean;
    days: number
    minutes: number;
    seconds: number;
    hours: number;
    dataClass: string;
    dataClassEx: string;
}

const ShortDaysSquare = ({ isExpired, days, minutes, seconds, hours, dataClass, dataClassEx }: IShortDaysSquare) => {
    return (
        <>
            {isExpired || (minutes === 0 && seconds === 0 && hours === 0 && days === 0) ?
                <></>
                :
                <ul className="flex">
                    <li className={dataClass}>
                        <div className="flex flex-col items-center justify-center">
                            <div>{days.toString().length === 1 ? "0" + days.toString() : days.toString()}</div>
                            <div className={dataClassEx}>days</div>
                        </div>
                    </li>
                    <li className={dataClass}>
                        <div className="flex flex-col items-center justify-center">
                            <div>{hours.toString().length === 1 ? "0" + hours.toString() : hours.toString()}</div>
                            <div className={dataClassEx}>hours</div>
                        </div>
                    </li>
                    <li className={dataClass}>
                        <div className="flex flex-col items-center justify-center">
                            <div>{minutes.toString().length === 1 ? "0" + minutes.toString() : minutes.toString()}</div>
                            <div className={dataClassEx}>mins</div>
                        </div>
                    </li>
                    <li className={dataClass.replace(" mr-3","")}>
                        <div className="flex flex-col items-center justify-center">
                            <div>{seconds.toString().length === 1 ? "0" + seconds.toString() : seconds.toString()}</div>
                            <div className={dataClassEx}>sec</div>
                        </div>
                    </li>
                </ul>
            }
        </>
    )
};

export default ShortDaysSquare;